import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import CommerceOnly from '/src/_includes/commerce-only.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <CommerceOnly mdxType="CommerceOnly" />
    <h1 {...{
      "id": "requisitionlistiteminterface-attributes-and-implementations"
    }}>{`RequisitionListItemInterface attributes and implementations`}</h1>
    <p><a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-RequisitionListItemInterface"
      }}><inlineCode parentName="a">{`RequisitionListItemInterface`}</inlineCode></a>{` provides details about items in a requisition list. It has the following implementations:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-BundleRequisitionListItem"
        }}><inlineCode parentName="a">{`BundleRequisitionListItem`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-ConfigurableRequisitionListItem"
        }}><inlineCode parentName="a">{`ConfigurableRequisitionListItem`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-DownloadableRequisitionListItem"
        }}><inlineCode parentName="a">{`DownloadableRequisitionListItem`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-GiftCardRequisitionListItem"
        }}><inlineCode parentName="a">{`GiftCardRequisitionListItem`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-SimpleRequisitionListItem"
        }}><inlineCode parentName="a">{`SimpleRequisitionListItem`}</inlineCode></a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#definition-VirtualRequisitionListItem"
        }}><inlineCode parentName="a">{`VirtualRequisitionListItem`}</inlineCode></a></li>
    </ul>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`There is not an implementation for grouped products. The items within a grouped product are managed individually.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following mutation adds a product to a requisition list and returns information about the products in the list.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  addProductsToRequisitionList(
      requisitionListUid: "Mg=="
      requisitionListItems: [
        {
            sku: "MS10"
            quantity: 1
            selected_options: ["Y29uZmlndXJhYmxlLzkzLzUw","Y29uZmlndXJhYmxlLzE2MC8xNjg"]
        }
      ]
    ) {
    requisition_list {
      uid
      items {
        items {
          ... on RequisitionListItemInterface {
            uid
            product {
              uid
              sku
              name
            }
            quantity
          }
        }
      }
      items_count
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "addProductsToRequisitionList": {
      "requisition_list": {
        "uid": "Mg==",
        "items": {
          "items": [
            {
              "uid": "Mg==",
              "product": {
                "uid": "MTA=",
                "sku": "24-WB05",
                "name": "Savvy Shoulder Tote"
              },
              "quantity": 1
            },
            {
              "uid": "Mw==",
              "product": {
                "uid": "NTk2",
                "sku": "MS10",
                "name": "Logan  HeatTec&reg; Tee"
              },
              "quantity": 1
            }
          ]
        },
        "items_count": 2
      }
    }
  }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      